import ReactDOM from 'react-dom';
import App from './components/App';

ReactDOM.render(<App />, document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./src/main.jsx
 **/